export const TABLE_PAGINATION_PAGES_BUFFER_SIZE = 2
